import { apiAuth, apiResponseType } from ".";

export const getFinancialReconciliationTransactionsData = (
  page: number = 1,
  filters = {}
): apiResponseType => {
  const queryParams = new URLSearchParams();
  queryParams.append("page", page.toString());

  // Adiciona os filtros aos parâmetros da query
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      queryParams.append(key, value.toString());
    }
  });

  return apiAuth.get(
    `financial-reconciliations/processes?${queryParams.toString()}`
  );
};

export const searchFinancialReconciliationTransactionsData = (params: {
  description?: string;
  amount?: string | number;
  unity_id?: string | number;
  expense_id?: string | number;
  revenue_id?: string | number;
  date_start_payment?: string;
  date_end_payment?: string;
  date_start?: string;
  date_end?: string;
  transaction_type_id?: string | number;
  status_id?: string | number;
}): apiResponseType => {
  const queryParams = new URLSearchParams();

  // Adiciona os parâmetros à query string se existirem
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      queryParams.append(key, value.toString());
    }
  });

  return apiAuth.get(
    `financial-reconciliations/processes?${queryParams.toString()}`
  );
};

export const storeFinancialReconciliationTransactionData = (data: {
  name: string;
  start_date: string;
  end_date: string;
}) =>
  apiAuth.post(
    "financial-reconciliations/processes/store",
    data
  ) as apiResponseType;

export const updateFinancialTransactionData = (uuid: string, data) =>
  apiAuth.post(
    `financial-reconciliations/processes/${uuid}/update`,
    data
  ) as apiResponseType;

export const deleteFinancialReconciliationTransactionData = (uuid: string) =>
  apiAuth.delete(
    `financial-reconciliations/processes/${uuid}/destroy`
  ) as apiResponseType;

export const getShowFinancialReconciliationTransaction = (
  uuid: string,
  params: Record<string, string> = {}
) =>
  apiAuth.get(
    `financial-reconciliations/processes/${uuid}/show?${new URLSearchParams(params).toString()}`
  ) as apiResponseType;

export const getAllReconciliationUuids = (
  uuid: string,
  params: Record<string, string> = {}
) =>
  apiAuth.get(
    `financial-reconciliations/processes/${uuid}/all-uuids?${new URLSearchParams(params).toString()}`
  ) as apiResponseType;

export const updateFinancialReconciliationTransactionData = (
  id: string,
  data: {
    payment_form_id: number;
    file: any;
  }
) =>
  apiAuth.postForm(
    `financial-reconciliations/${id}/carry-out-conciliation/upload`,
    data
  ) as apiResponseType;

export const updateManualReconciliationData = (
  uuid: string,
  data: {
    reconciled_amount: number;
    source_description: string;
    reconciliation_status_id: number;
  }
) =>
  apiAuth.put(
    `financial-reconciliations/${uuid}/manual-reconciliation`,
    data
  ) as apiResponseType;

export const importBTGFile = (data: { file: File }) =>
  apiAuth.postForm(
    `financial-reconciliations/btg/import`,
    data
  ) as apiResponseType;

// Conciliação assíncrona (fila)
export const startReconciliationAsync = (
  processId: string,
  data: {
    payment_form_id: number;
    file: File;
  }
) =>
  apiAuth.postForm(
    `financial-reconciliations/${processId}/start-async`,
    data
  ) as apiResponseType;

export const getReconciliationJobStatus = (jobUuid: string) =>
  apiAuth.get(
    `financial-reconciliations/job/${jobUuid}/status`
  ) as apiResponseType;

export const getReconciliationJobsByProcess = (processId: string | number) =>
  apiAuth.get(
    `financial-reconciliations/process/${processId}/jobs`
  ) as apiResponseType;

export const reconcileCentsDifference = (uuid: string) =>
  apiAuth.post(
    `financial-reconciliations/processes/${uuid}/reconcile-cents-difference`
  ) as apiResponseType;

// Divergentes: linhas do arquivo sem par na conciliação
export const getUnmatchedEntries = (
  uuid: string,
  params: Record<string, string> = {}
) =>
  apiAuth.get(
    `financial-reconciliations/processes/${uuid}/unmatched-entries?${new URLSearchParams(params).toString()}`
  ) as apiResponseType;

export const launchUnmatchedEntries = (
  uuid: string,
  data: {
    entries: string[];
    unity_id: number;
    expense_type_id?: number;
    revenue_type_id?: number;
  }
) =>
  apiAuth.post(
    `financial-reconciliations/processes/${uuid}/unmatched-entries/launch`,
    data
  ) as apiResponseType;
